module.exports = __webpack_public_path__ + "static/media/Icon-awesome-city.ad3949f7.svg";